import { memo, ReactNode } from "react";

const TrunkLeafNavigationTrunkScreen = ({
	renderLeafScreen,
	props,
}: {
	renderLeafScreen: (props: any) => ReactNode;
	props: any;
}) => {
	return renderLeafScreen(props);
};
export default memo(TrunkLeafNavigationTrunkScreen);
